export const formatRut = (value = '') =>
  value
    .replace(/[^0-9kK]/g, '')
    .replace(/^(\d{1,2})(\d{3})(\d{3})([0-9kK])$/, '$1.$2.$3-$4')
    .toUpperCase();

export const normalizeRut = (value = '') =>
  value.replace(/[^0-9kK]/g, '').toLowerCase();
